<script>
    export let itemInfo;
</script>

<div class="info-table-box">
    <table class="info-table">
        <tbody>
            {#each itemInfo as x}
                {#if x.key == "divider"}
                    <tr>
                        <td class="no-border divider-line" />
                        <td class="no-border divider-line" />
                    </tr>
                    <tr>
                        <td class="no-border divider-spacer" />
                        <td class="no-border divider-spacer" />
                    </tr>
                {:else}
                    <tr>
                        <td class="no-border item-title-col">
                            {x.title + ":"}
                        </td>
                        <td class="no-border item-value-col">
                            {x.value}
                        </td>
                    </tr>
                {/if}
            {/each}
        </tbody>
    </table>
</div>

<!-- </div> -->
<style>
    .info-table {
        margin: 0 auto;
    }
    .item-title-col {
        padding: 2px 8px 2px 0;
        font-weight: 600;
        height: 1.1rem;
    }
    .item-value-col {
        padding: 2px 0 2px 8px;
        height: 1.1rem;
    }
    .divider-line {
        height: 4px;
        border-bottom: 0.25px solid lightgray;
    }
    .divider-spacer {
        height: 4px;
    }
</style>
